var _ellipse, _mask, _g, _path, _path2, _path3, _g2, _rect, _rect2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 161,
    viewBox: "0 0 178 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 56.6888,
    ry: 56.7961,
    transform: "matrix(-0.965784 0.259347 -0.258292 -0.966067 69.4192 72.429)",
    fill: "#F6F6F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 15,
    width: 115,
    height: 115
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 56.6888,
    ry: 56.7961,
    transform: "matrix(-0.965784 0.259347 -0.258292 -0.966067 69.4197 72.429)",
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 64.3053C10.6943 61.5438 12.9329 59.3053 15.6943 59.3053H102.657C105.419 59.3053 107.657 61.5438 107.657 64.3053V92.8894C107.657 95.6508 105.419 97.8894 102.657 97.8894H15.6943C12.9329 97.8894 10.6943 95.6508 10.6943 92.8894V64.3053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.9629,
    y: 71.4521,
    width: 14.2593,
    height: 14.2904,
    rx: 2,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6379 76.8349L28.7623 76.5848L27.6394 73.9351C27.4374 73.4528 26.7482 73.4528 26.5462 73.9351L25.4233 76.5907L22.5536 76.8349C22.0307 76.8765 21.8169 77.5315 22.2149 77.8769L24.3954 79.7703L23.7419 82.5808C23.623 83.0929 24.1756 83.4978 24.6271 83.2239L27.0928 81.7353L29.5584 83.2298C30.01 83.5037 30.5625 83.0988 30.4437 82.5868L29.7902 79.7703L31.9706 77.8769C32.3687 77.5315 32.1608 76.8765 31.6379 76.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6479,
    y: 71.4521,
    width: 14.2593,
    height: 14.2904,
    rx: 2,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.323 76.8349L44.4474 76.5848L43.3244 73.9351C43.1224 73.4528 42.4332 73.4528 42.2312 73.9351L41.1083 76.5907L38.2386 76.8349C37.7158 76.8765 37.5019 77.5315 37.9 77.8769L40.0805 79.7703L39.4269 82.5808C39.3081 83.0929 39.8606 83.4978 40.3122 83.2239L42.7778 81.7353L45.2435 83.2298C45.695 83.5037 46.2476 83.0988 46.1288 82.5868L45.4752 79.7703L47.6557 77.8769C48.0538 77.5315 47.8458 76.8765 47.323 76.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3335,
    y: 71.4521,
    width: 14.2593,
    height: 14.2904,
    rx: 2,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0085 76.8349L60.1329 76.5848L59.01 73.9351C58.808 73.4528 58.1188 73.4528 57.9168 73.9351L56.7939 76.5907L53.9242 76.8349C53.4014 76.8765 53.1875 77.5315 53.5855 77.8769L55.766 79.7703L55.1125 82.5808C54.9936 83.0929 55.5462 83.4978 55.9977 83.2239L58.4634 81.7353L60.929 83.2298C61.3806 83.5037 61.9331 83.0988 61.8143 82.5868L61.1608 79.7703L63.3412 77.8769C63.7393 77.5315 63.5314 76.8765 63.0085 76.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.0186,
    y: 71.4521,
    width: 14.2593,
    height: 14.2904,
    rx: 2,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6936 76.8349L75.818 76.5848L74.6951 73.9351C74.493 73.4528 73.8038 73.4528 73.6018 73.9351L72.4789 76.5907L69.6093 76.8349C69.0864 76.8765 68.8725 77.5315 69.2706 77.8769L71.4511 79.7703L70.7975 82.5808C70.6787 83.0929 71.2312 83.4978 71.6828 83.2239L74.1484 81.7353L76.6141 83.2298C77.0657 83.5037 77.6182 83.0988 77.4994 82.5868L76.8458 79.7703L79.0263 77.8769C79.4244 77.5315 79.2164 76.8765 78.6936 76.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.7036,
    y: 71.4521,
    width: 14.2593,
    height: 14.2904,
    rx: 2,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3786 76.8349L91.503 76.5848L90.3801 73.9351C90.1781 73.4528 89.4889 73.4528 89.2869 73.9351L88.164 76.5907L85.2943 76.8349C84.7715 76.8765 84.5576 77.5315 84.9557 77.8769L87.1361 79.7703L86.4826 82.5808C86.3638 83.0929 86.9163 83.4978 87.3678 83.2239L89.8335 81.7353L92.2992 83.2298C92.7507 83.5037 93.3033 83.0988 93.1844 82.5868L92.5309 79.7703L94.7114 77.8769C95.1094 77.5315 94.9015 76.8765 94.3786 76.8349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3428 116.716C46.3428 126.965 46.3949 134.478 46.4656 134.402C46.5331 134.329 48.2959 131.937 50.3829 129.088C52.4699 126.238 54.2284 123.889 54.2905 123.867C54.3529 123.845 56.2395 127.068 58.4831 131.029L62.5623 138.231L65.5685 136.461C67.7208 135.195 68.5574 134.632 68.5135 134.48C68.4798 134.364 66.6944 131.15 64.5458 127.337L60.6394 120.405L67.7442 120.335L74.8491 120.265L60.7872 109.693C53.0531 103.878 46.6393 99.0699 46.5341 99.0083C46.3725 98.9137 46.3428 101.674 46.3428 116.716Z",
    fill: "#526775",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9199 112.741C49.9199 122.991 49.972 130.504 50.0427 130.427C50.1102 130.354 51.873 127.963 53.96 125.113C56.047 122.263 57.8055 119.914 57.8677 119.892C57.93 119.871 59.8166 123.094 62.0602 127.055L66.1395 134.256L69.1456 132.487C71.298 131.22 72.1345 130.657 72.0907 130.506C72.057 130.389 70.2715 127.175 68.1229 123.363L64.2165 116.431L71.3213 116.361L78.4262 116.291L64.3644 105.718C56.6303 99.9033 50.2164 95.0953 50.1112 95.0336C49.9497 94.9391 49.9199 97.6989 49.9199 112.741Z",
    fill: "#526775"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5263 38.1864L83.6313 37.6737L81.3293 32.2419C80.9152 31.2532 79.5024 31.2532 79.0883 32.2419L76.7863 37.6859L70.9035 38.1864C69.8316 38.2718 69.3932 39.6145 70.2092 40.3225L74.6792 44.2042L73.3394 49.9656C73.0958 51.0153 74.2285 51.8454 75.1542 51.2839L80.2088 48.2323L85.2634 51.2961C86.1891 51.8576 87.3218 51.0275 87.0782 49.9778L85.7384 44.2042L90.2084 40.3225C91.0244 39.6145 90.5982 38.2718 89.5263 38.1864Z",
    fill: "#FFD700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7498 23.0695L59.5866 22.7944L58.3514 19.8797C58.1292 19.3492 57.371 19.3492 57.1488 19.8797L55.9136 22.8009L52.757 23.0695C52.1819 23.1153 51.9466 23.8358 52.3845 24.2157L54.783 26.2985L54.0641 29.39C53.9334 29.9533 54.5412 30.3987 55.0379 30.0974L57.7501 28.46L60.4623 30.1039C60.959 30.4052 61.5668 29.9598 61.4361 29.3966L60.7172 26.2985L63.1157 24.2157C63.5536 23.8358 63.3249 23.1153 62.7498 23.0695Z",
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5983 3.76791L84.5854 3.59285L83.7993 1.73807C83.6579 1.40046 83.1755 1.40046 83.0341 1.73807L82.248 3.59702L80.2393 3.76791C79.8733 3.79708 79.7236 4.25557 80.0022 4.49732L81.5285 5.82275L81.0711 7.79007C80.9879 8.14852 81.3747 8.43195 81.6907 8.24022L83.4167 7.19821L85.1427 8.24438C85.4587 8.43611 85.8455 8.15269 85.7624 7.79424L85.3049 5.82275L86.8312 4.49732C87.1099 4.25557 86.9643 3.79708 86.5983 3.76791Z",
    fill: "#FFD700"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8428 108.606C84.8428 105.844 87.0813 103.606 89.8428 103.606H149C151.762 103.606 154 105.844 154 108.606V126.472C154 129.233 151.762 131.472 149 131.472H89.8428C87.0813 131.472 84.8428 129.233 84.8428 126.472V108.606Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.9722,
    y: 110.036,
    width: 24.9537,
    height: 2.85808,
    rx: 1.42904,
    fill: "#DADADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9722,
    y: 117.181,
    width: 54.1852,
    height: 2.85808,
    rx: 1.42904,
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0302 131.142C49.9595 131.218 49.9074 123.705 49.9074 113.455C49.9074 98.4134 49.8686 96.7231 50.0301 96.8176C50.1354 96.8793 56.6177 100.618 64.3518 106.433L62.7407 113.455L57.8552 112.537L64.204 117.145L57.8552 120.607C57.793 120.628 56.0345 122.978 53.9475 125.827C51.8605 128.677 50.0977 131.069 50.0302 131.142Z",
    fill: "#526775"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -13.3057,
    y: 59.3053,
    width: 144.963,
    height: 86.5841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619792 0 0 0 0 0.69078 0 0 0 0 0.729167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 60.8428,
    y: 84.6056,
    width: 117.157,
    height: 75.8663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619792 0 0 0 0 0.69078 0 0 0 0 0.729167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.9eedbaf7.svg";
export { ForwardRef as ReactComponent };